import workloadReducer from './reducers';
import * as workloadActions from './actions';

export default workloadReducer;

export { workloadActions };
